export default __webpack_public_path__ + "static/media/github-min.14917ede.jpg";